<template>
  <li :class="{'star': $props.star}">
    <svg v-if="$props.star" width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Lodge-Page-2" transform="translate(-528.000000, -1210.000000)" fill="#5FADEF" fill-rule="nonzero">
                <g id="At-this-park" transform="translate(524.000000, 1096.000000)">
                    <g id="Chlidrens" transform="translate(4.000000, 114.000000)">
                        <g id="star-black-shape-in-a-circle-outline-favourite-interface-symbol">
                            <polygon id="Path" points="12.1608219 7.12716243 10.0537378 2.85984344 7.94911937 7.12716243 3.24101761 7.81041096 6.64771037 11.1318591 5.84313112 15.8214481 10.0537378 13.6080626 14.2668493 15.8214481 13.4624658 11.1318591 16.868728 7.81041096"></polygon>
                            <path d="M9.98403131,0 C4.47886497,0 0.000195694716,4.47866928 0.000195694716,9.98426614 C0.000195694716,15.4896282 4.47886497,19.9680235 9.98399217,19.9680235 C15.4889237,19.9680235 19.9677886,15.489589 19.9677886,9.98426614 C19.9682975,4.47866928 15.489863,0 9.98403131,0 Z M9.98403131,19.0320939 C4.99510763,19.0320939 0.936242661,14.973229 0.936242661,9.98430528 C0.936242661,4.99491194 4.99510763,0.936007828 9.98403131,0.936007828 C14.972955,0.936007828 19.03182,4.99491194 19.03182,9.98430528 C19.0322896,14.9731898 14.9734247,19.0320939 9.98403131,19.0320939 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    
  <svg v-else width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Lodge-Page-2" transform="translate(-528.000000, -1270.000000)">
              <g id="At-this-park" transform="translate(524.000000, 1096.000000)">
                  <g id="Indoor-heated-pool" transform="translate(4.000000, 174.000000)">
                      <g id="checked" transform="translate(0.000000, 0.000000)">
                          <polygon id="Clip-2" points="0 0.0155971897 19.9844028 0.0155971897 19.9844028 19.9971897 0 19.9971897"></polygon>
                          <path d="M8.15920375,15.1405621 L3.75948478,10.7410304 L5.22590164,9.27456674 L8.15920375,12.2076815 L14.7584543,5.60824356 L16.224918,7.07466042 L8.15920375,15.1405621 Z M9.99217799,0.0155971897 C4.47391101,0.0155971897 0,4.48932084 0,10.0077752 C0,15.5262763 4.47391101,20 9.99217799,20 C15.5111007,20 19.9844028,15.5262763 19.9844028,10.0077752 C19.9844028,4.48932084 15.5108665,0.0155971897 9.99217799,0.0155971897 Z" id="Fill-1" fill="#5FADEF"></path>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
    <p>{{attraction}}</p>
  </li>
</template>

<script>
import Gallery from '../shared/gallery.vue'

export default {
  props: {
    attraction: {
          type: String,
          required: true
      },
    star: Boolean
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

li {
  width: 100%;
  padding: 1.5rem 1rem 0 0;
  box-sizing: border-box; 
  display:flex;

  svg,
  p {
    display: inline;
    font-size: .875rem;
  }

  svg {
    min-width: 1.25rem;
    min-height: 1.25rem;
    margin-top: 0.1rem;
  }

  p {
    padding: .25rem 0 0 1rem;
  }

  &.star {
    font-weight: 700;

    svg {
      fill: $col_primary;
      background: transparent;
    }
  }
}

  @media #{$desktop} {
    
    li {
      width: 50%;
    }
  }


</style>